import en from './translations.json';
export default {
  en: en
};